import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { assets } from "../../mock";

const POOL = [
  [assets.heroQ3x, "Q3X", "q3x-f-rt"], ["/api/media/easysistem/media/custom/4fadb77ecb-previewookk-edge-k-1500x1500.png", "EDGE-K", "edge-k"],
  ["/img/hero/k3n.webp", "K3-N RT", "k3-f-rt"], ["/img/hero/cassetti.webp", "Cassetto rendiresto", "cassetti-rendiresto"],
  ["/img/hero/fusionk.webp", "FUSION K", "fusion-k"], ["/img/hero/omnitouch.webp", "OMNI TOUCH", "omni-touch"],
  ["/img/hero/p3n.webp", "P3-N RT", "p3-n-rt"], ["/img/hero/kube.webp", "KUBE III", "kube-iii-lottery"],
  ["/img/hero/edgen.webp", "EDGE-N+", "edge-n+"], ["/img/hero/silk.webp", "SILK II", "silk-ii"],
  ["/img/hero/bigplus.webp", "BIG PLUS-N RT", "black-white"], ["/img/hero/mach.webp", "Mach 2120", "mach-2120"],
  ["/img/hero/jsmart.webp", "JSMART-N RT", "jsmart-rt"], ["/img/hero/trek.webp", "TREK", "trek-15_6-and"],
  ["/img/hero/fusionn.webp", "FUSION-N 2.0", "fusion-n-2-0-rt"], ["/img/hero/omnikey.webp", "OMNI KEY", "omni-key"],
];
const PAIRS = POOL.length / 2;
const EVERY = 120000;
const SLOTS = [{ pos: "left-[16%] top-[14%]", w: "w-[170px] lg:w-[190px]" }, { pos: "left-[44%] top-[20%]", w: "w-[220px] lg:w-[250px]" }];
const rnd = (a, b) => a + Math.random() * (b - a);

const Item = ({ src, alt, slug, slot, phase, delay }) => {
  const float = useMemo(() => ({ "--es-lift": `${-rnd(6, 14).toFixed(1)}px`, "--es-tilt": `${rnd(-2, 2).toFixed(1)}deg`, animationDuration: `${rnd(5, 8).toFixed(1)}s`, animationDelay: `${rnd(0, 2).toFixed(1)}s` }), [src]);
  return (
    <div className={`absolute ${SLOTS[slot].pos} ${phase === "out" ? "es-hero-out" : "es-hero-in"}`} style={{ animationDelay: `${delay}ms` }}>
      <Link to={`/prodotti/${encodeURIComponent(slug)}`} aria-label={`Scheda ${alt}`} tabIndex={phase === "out" ? -1 : 0} className="es-levitate group flex flex-col items-center cursor-pointer" style={float} data-testid={`hero-carousel-link-${slot}`}>
        <img src={src} alt={alt} className={`${SLOTS[slot].w} max-h-[210px] object-contain drop-shadow-2xl transition-transform duration-300 group-hover:scale-105`} data-testid={`hero-carousel-img-${slot}`} />
        <span className="mt-1 text-[10px] font-bold uppercase tracking-[0.18em] text-white/60 group-hover:text-white transition-colors">{alt} · Scopri</span>
      </Link>
    </div>
  );
};

export const HeroCarousel = () => {
  const [i, setI] = useState(0); const [prev, setPrev] = useState(null);
  useEffect(() => {
    const t = setInterval(() => setI((x) => { setPrev(x); return (x + 1) % PAIRS; }), EVERY);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    const n = (i + 1) % PAIRS; [POOL[n * 2], POOL[n * 2 + 1]].forEach(([s]) => { const im = new Image(); im.src = s; });
    if (prev === null) return; const t = setTimeout(() => setPrev(null), 1400); return () => clearTimeout(t);
  }, [i]); // eslint-disable-line
  const pair = (k) => [POOL[k * 2], POOL[k * 2 + 1]];
  return (
    <div className="absolute inset-0" data-testid="hero-carousel">
      {prev !== null && pair(prev).map(([s, a, g], k) => <Item key={`o-${prev}-${k}`} src={s} alt={a} slug={g} slot={k} phase="out" delay={k * 120} />)}
      {pair(i).map(([s, a, g], k) => <Item key={`i-${i}-${k}`} src={s} alt={a} slug={g} slot={k} phase="in" delay={prev === null ? 200 + k * 250 : 500 + k * 220} />)}
    </div>
  );
};
